import { StatusFilterType } from '@app/modules/logger/screens/status/components/options';
import { parseAsString, parseAsStringEnum, useQueryStates } from 'nuqs';
import { parseAsStationTypeFilter } from './parse-as-station-type-filter';

/**
 * Hook that syncs status screen filters (text, status, type) with URL query params.
 * Uses nuqs for type-safe serialization. URL is the source of truth.
 */
export function useStatusQueryFilter() {
  const [queryParams, setQueryParams] = useQueryStates(
    {
      text: parseAsString.withDefault(''),
      status: parseAsStringEnum(Object.values(StatusFilterType)).withDefault(StatusFilterType.ALL),
      // Optional: when absent or null = show all. Comma-separated when multiple types are selected.
      type: parseAsStationTypeFilter,
    },
    {
      history: 'replace',
    },
  );

  return {
    queryParams,
    setQueryParams,
  };
}
